import { render } from "./IconFilter.vue?vue&type=template&id=6d1004a4"
import script from "./IconFilter.vue?vue&type=script&lang=js"
export * from "./IconFilter.vue?vue&type=script&lang=js"
script.render = render

export default script